import { useEffect, useState } from 'react';
import { showToast } from './Messages';

const DocFav = ({ onClose, folderList, setFolderList, folderItemList, setFolderItemList, setIsAddingManual, userId, manualId, locationFrom }) => {
    const [localFolderList, setLocalFolderList] = useState(folderList);
    const [newFolderName, setNewFolderName] = useState('');
    const [isAddingFolder, setIsAddingFolder] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [activeMenu, setActiveMenu] = useState(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest('.folder-list-each')) {
                setActiveMenu(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        if (!folderList[selectedIndex]) {
            setSelectedIndex(0);
        }
    }, [folderList]);

    const handleAddFolderClick = () => {
        setNewFolderName('');
        setEditingIndex(null);
        setIsAddingFolder(true);
    };

    const handleAddFolderComplete = () => {
        if (newFolderName.trim()) {
            if (editingIndex !== null) {
                saveFavoriteManualFolder('U', folderList[editingIndex].folderSeq);
                setEditingIndex(null);
            } else {
                saveFavoriteManualFolder('A');
            }
        }
    };

    const handleMenuToggle = (index) => {
        setActiveMenu(activeMenu === index ? null : index);
    };

    const handleLiClick = (index) => {
        setSelectedIndex(index);
    };

    const handleInputChange = (e) => {
        setNewFolderName(e.target.value);
    };

    const handleAddFolderCancel = () => {
        setNewFolderName('');
        setEditingIndex(null);
        setIsAddingFolder(false);
    };

    const handleEditFolderClick = (index) => {
        setIsAddingFolder(false);
        setEditingIndex(index);
        setNewFolderName(folderList[index].folderName);
    };

    const handleDeleteFolder = (index) => {
        const userResponse = window.confirm("폴더를 삭제하시겠습니까?");
        if (userResponse) {
            saveFavoriteManualFolder('D', folderList[index].folderSeq);
        }
    };

    const saveFavoriteManualFolder = (workingTag, folderSeq) => {
        if (userId === '') return;
        const body = {
            workingTag: workingTag,
            devUserId: userId,
            folderSeq: workingTag === 'A' ? 0 : folderSeq,
            folderName: newFolderName
        };
        fetch(`api/Document/SaveFavoriteManualFolder`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.message === 'Success') {
                    setFolderList(resultData.data.table.length > 0 ? resultData.data.table : []);
                    setLocalFolderList(resultData.data.table.length > 0 ? resultData.data.table : []);
                }
                else {
                    showToast('danger', '저장 실패');
                }
                setNewFolderName('');
                setIsAddingFolder(false);
            });
    };

    const saveFavoriteManualFolderItem = () => {
        if (userId === ''
            || folderItemList.some((item) => item.folderSeq === folderList[selectedIndex].folderSeq && item.manualId === manualId)) return;
        if (selectedIndex === null) {
            showToast('warning', '폴더를 선택해주세요.');
            return;
        }
        const body = {
            workingTag: 'A',
            devUserId: userId,
            folderSeq: folderList[selectedIndex].folderSeq,
            folderItemSeq: 0,
            manualId: manualId
        };
        fetch(`api/Document/SaveFavoriteManualFolderItem`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.message === 'Success') {
                    setFolderItemList(resultData.data.table.length > 0 ? resultData.data.table : []);
                    setIsAddingManual(true);
                    onClose(null);
                }
                else {
                    showToast('danger', '저장 실패');
                }
            });
    };

    return (
        <div className="msg-popup center-box">
            <div className='modal'>
                <div className='modal-top'>
                    <h3 className='modal-title'>즐겨찾기</h3>
                    <button className="btn-close" onClick={() => onClose(null)}>
                        <i className="icoKdc32 close"></i>
                    </button>
                </div>
                <div className='modal-cnts'>
                    <button className='btn-addfolder' onClick={handleAddFolderClick}>
                        <i className='icoKdc20 add-g'></i>폴더추가
                    </button>
                    <div className='folder-list-wrap'>
                        <ul className="folder-list">
                            {localFolderList.map((folder, index) => (
                                <li
                                    key={index}
                                    className={editingIndex === index ? 'folder-list-add' : `folder-list-each ${selectedIndex === index ? 'selected' : ''}`}
                                    onClick={() => handleLiClick(index)}
                                >
                                    {editingIndex === index ? (
                                        <div className="add-folder-name">
                                            <div class="icon-title-wrap">
                                                <i className='icoKdc24 bmrkfolder'></i>
                                                <input
                                                    placeholder="폴더명 입력"
                                                    value={newFolderName}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="add-folder-btns-wrap">
                                                <button className='btn-cancel' onClick={handleAddFolderCancel}>취소</button>
                                                <button className='btn-add' onClick={handleAddFolderComplete}>완료</button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="folder-name-wrap">
                                                <i className="icoKdc24 bmrkfolder"></i>
                                                <span className="folder-name">{folder.folderName}</span>
                                            </div>
                                            <button onClick={() => handleMenuToggle(index)}>
                                                <i className='icoKdc24 kebab-24'></i>
                                                {activeMenu === index && (
                                                    <div className="context-menu">
                                                        <ul>
                                                            <li onClick={() => handleEditFolderClick(index)}><a className='default'>폴더명 변경</a></li>
                                                            <li onClick={() => handleDeleteFolder(index)}><a className="nega">삭제</a></li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </button>
                                        </>
                                    )}
                                </li>
                            ))}
                            {isAddingFolder && (
                                <li className="folder-list-add">
                                    <i className='icoKdc24 bmrkfolder'></i>
                                    <div className="add-folder-name">
                                        <input
                                            placeholder="새 폴더명 입력"
                                            value={newFolderName}
                                            onChange={handleInputChange}
                                            autoFocus
                                        />
                                        <div className="add-folder-btns-wrap">
                                            <button className='btn-cancel' onClick={handleAddFolderCancel}>취소</button>
                                            <button className='btn-add' onClick={handleAddFolderComplete}>완료</button>
                                        </div>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
                {locationFrom === 'contentViewer' && (
                    <div className="mail-list-btm">
                        <button className='btn-share' onClick={() => saveFavoriteManualFolderItem()}>저장</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DocFav;